import { NgIf } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '@vg-constellation/angular-20/icon';
import { InputModule } from '@vg-constellation/angular-20/input';
import { KeyboardEventRegexValidateDirective } from 'src/app/directives/keyboard-event-regex-validate.directive';

@Component({
    selector: 'zci-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    imports: [
        NgIf,
        ReactiveFormsModule,
        IconModule,
        InputModule,
        KeyboardEventRegexValidateDirective,
    ],
})
export class SearchFieldComponent {
    @Input() placeholder: string;

    @Input() removeButtonAriaLabel: string;

    @Input() regex: RegExp;

    @Output() emitSearchValue: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild('searchInput') searchInputElement: ElementRef<HTMLInputElement>;

    searchField: FormControl = new FormControl();

    onApproveSearchValue() {
        this.emitSearchValue.emit(this.searchField.value);
    }

    onRemoveSearchValue() {
        this.searchField.reset();
        /* istanbul ignore next */
        this.searchInputElement.nativeElement?.focus();
    }
}
